/** @format */

import { Badge, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import FeatureFlag from "../featureFlag/FeatureFlag";
import { selectIsEditing, setIsEditing } from "./editableSlice";
import "./editable.scss";
import { Resource, UserResource } from "../resources/types";
import TranslationWidget from "./translation/TranslationWidget";
import { useTranslation } from "react-i18next";
import { getRefLink } from "./GetRefLink";

const EditableSwitch: React.FC<{
  resource?: Resource | UserResource;
}> = ({ resource }) => {
  const isEditing = useAppSelector(selectIsEditing());
  const dispatch = useDispatch();
  const handleChange = () => {
    dispatch(setIsEditing(!isEditing));
  };
  const { t: _ } = useTranslation();

  const user = useAppSelector((state) => state.auth.userInfo);
  const isStaff = useAppSelector((state) => state.auth.isStaff);

  return (
    <FeatureFlag
      flag={["editable", "dev"]}
      fallback={
        <p className="px-3 pb-3">
          {_("You are not able to edit at this time.")}
        </p>
      }
    >
      <div
        className={`py-2 px-2 px-sm-3 editable-header container-fluid ${
          !isEditing && "isReading"
        }`}
      >
        <div
          className="d-flex position-relative justify-content-between align-items-center"
          style={{ height: "calc(1.5rem)" }}
        >
          <div className="d-flex align-items-center">
            {resource && (
              <Badge bg="editing" className="me-3 d-none d-sm-block">
                {_(resource.Status?.toUpperCase()) ?? _("draft")}
              </Badge>
            )}
            <Form.Switch
              onChange={handleChange}
              aria-label={isEditing ? _("Edit View") : _("Read View")}
              checked={isEditing}
            />
          </div>
          <div>
            {!isEditing && (
              <a
                className="btn btn-sm px-3 me-2 btn-editing"
                href={getRefLink(resource as Resource)}
              >
                {_("Done")}
              </a>
            )}
            {user &&
              (resource?.PK.includes("USER_BL#") ? (
                <TranslationWidget resource={resource} userResource={true} />
              ) : (
                isStaff && (
                  <TranslationWidget resource={resource} userResource={false} />
                )
              ))}
          </div>
        </div>
      </div>
    </FeatureFlag>
  );
};

export default EditableSwitch;
